import React, { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { samplePrompt } from '../../Service/ServerAPI';
import SampleQueryCard from './SampleQueryCard';

const useStyles = makeStyles({
  buttonGrid: {
    marginTop: '30px',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
  },
});

const options = [
  {
    title: "Can't access data on GSC?",
    description: "How do I get the right RBAC to be able to start using GSC?",
    icon: "⚙️",
    highlighted: true,
    onClick: () => console.log("RBAC Chat Prompt")
  },
  {
    title: "Audience Size #1",
    description: "How many players have an active Game Pass subscription with auto renew off?",
    icon: "📊"
  },
  {
    title: "Audience Size #2",
    description: "Players who played any of the Elder Scrolls games.",
    icon: "🕹️"
  },
  {
    title: "Audience Size #3",
    description: "How many players played Fortnite within the first month of creating their XBL accounts?",
    icon: "📺"
  },
  {
    title: "Audience Size #4",
    description: "Players who have played for more than 10 hours in the last month and have more than 5 friends.",
    icon: "🎮"
  },
  {
    title: "Brainstorm Ideas",
    description: "Suggest me campaign ideas to improve the retention of PC Game Pass users.",
    icon: "💡",
  },
];

// This is the back-up sample prompts in case the user is unauthenticated or the server is down
const unauthedOrServerErrorSamplePrompts : samplePrompt[] = [
    {
        title: "New or can't access data on GSC?",
        description: "How can I get added to the right RBAC to be able to start using GSC?",
        icon: "ℹ️"
    },
    {
        title: "Explore Gaming Data",
        description: "What data about gamers do you have?",
        icon: "❓",
        disabled: true
    },
    {
        title: "Audience Size #1",
        description: "How many players have an active Game Pass subscription with auto renew off?",
        icon: "📊",
        disabled: true
    },
    {
        title: "Audience Size #2",
        description: "How many users played Hellblade 1 but not Hellblade 2?",
        icon: "🕹️",
        disabled: true
    },
    {
        title: "Audience Size #3",
        description: "How many players played Fortnite within the first month of creating their XBL accounts?",
        icon: "📺",
        disabled: true
    },
    {
        title: "Brainstorm Ideas",
        description: "Suggest me campaign ideas to improve the retention of PC Game Pass users.",
        icon: "💡",
        disabled: true
    },
];

interface WelcomeProps {
  onButtonClick: (description: string, index: number) => void;
  isAuthed: boolean;
  isActivision: boolean;
  samplePrompts: samplePrompt[];
}

const WelcomeScreen: React.FC<WelcomeProps> = ({ onButtonClick, isAuthed, isActivision, samplePrompts }) => {
  const classes = useStyles();

  const handleButtonClick = (index: number, description: string) => {
    onButtonClick(description, index);
  };

 const promptsToDisplay: samplePrompt[] = isAuthed? samplePrompts : unauthedOrServerErrorSamplePrompts;
 const showActivisionPrompts: boolean = isAuthed ? isActivision : false;

 const disabledTooltip = showActivisionPrompts
     ? 'You cannot generate audience sizes based on play history, app usage or purchases for titles that are outside of the Activision publishing portfolio.'
     : 'Please ensure you have the proper permissions.';

  return (
    <div className={classes.buttonGrid}>
      {promptsToDisplay.map((option, index) => (
        <SampleQueryCard
          key={index}
          title={option.title}
          description={option.description}
          icon={option.icon}
          highlighted={index === 0 && isAuthed}
          disabled={(!isAuthed && index !== 0) || option.disabled}
          disabledTooltip={disabledTooltip}
          onClick={() => handleButtonClick(index, option.description)}
        />
      ))}
    </div>
  );
};

export default WelcomeScreen;